import { render, staticRenderFns } from "./confirm-delete-point.vue?vue&type=template&id=24208706&scoped=true"
import script from "./confirm-delete-point.vue?vue&type=script&lang=js"
export * from "./confirm-delete-point.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-point.vue?vue&type=style&index=0&id=24208706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24208706",
  null
  
)

export default component.exports